import { render, staticRenderFns } from "./CarAftherMarket.vue?vue&type=template&id=dcca03b0&scoped=true&"
import script from "./CarAftherMarket.vue?vue&type=script&lang=js&"
export * from "./CarAftherMarket.vue?vue&type=script&lang=js&"
import style0 from "./CarAftherMarket.vue?vue&type=style&index=0&id=dcca03b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcca03b0",
  null
  
)

export default component.exports